import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_SECURITY_TOTAL_KEY,
  SHEET_ALIASES_CONSTANTS,
  SHEET_TITLES_CONSTANTS,
} from 'pages/ValuationsAllocation/common/constants/weightedShareValues';
import { getNumberValue } from 'utilities';


const { ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADER_TITLE } = SHEET_ALIASES_CONSTANTS;

const { ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADERS } = SHEET_TITLES_CONSTANTS;
const { VALUE } = ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADERS;

const excludedAliases = [
  ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADER_TITLE,
  ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_SECURITY_TOTAL_KEY
]

const getFirmTotal = (weightedShareValuesCells: (ICell & { isRelatedEntityInvestmentInCompany: boolean })[]) => {
  const firmTotal = getNumberValue(
    weightedShareValuesCells
      ?.filter(
        (spreadsheetCell) => {
          const {isRelatedEntityInvestmentInCompany} = spreadsheetCell; 
          const isExcludedAlias = excludedAliases.includes(spreadsheetCell.alias)
          const isValueCell = spreadsheetCell.y === VALUE.columnNumber - 1

          const shouldIncludeCellInCalculation = !isExcludedAlias
            && isValueCell
            && !isRelatedEntityInvestmentInCompany

          return shouldIncludeCellInCalculation
        }
      )
      ?.reduce((accumulator, current) => accumulator + getNumberValue(current?.value as number), 0)
  );

  return firmTotal;
};

export default getFirmTotal;
